export const GUIDANCE_MENU_BASE = "auto-suggest-guidance-menu-base";
export const GUIDANCE_MENU_TAB_SELECTS_VALUE =
  "auto-suggest-guidance-menu-tab-selects-value";
export const GUIDANCE_INPUT_ARIA_LABEL_FALLBACK =
  "auto-suggest-guidance-input-aria-label-fallback";
export const GUIDANCE_INPUT_BASE = "auto-suggest-guidance-input-base";
export const GUIDANCE_INPUT_IS_SEARCHABLE =
  "auto-suggest-guidance-input-is-searchable";
export const GUIDANCE_INPUT_OPEN_MENU = "auto-suggest-guidance-input-open-menu";
export const GUIDANCE_VALUE = "auto-suggest-guidance-value";
export const ON_CHANGE_DESELECTED = "auto-suggest-on-change-deselected";
export const ON_CHANGE_CLEAR = "auto-suggest-on-change-clear";
export const ON_CHANGE_INITIAL_INPUT_FOCUS_SINGULAR =
  "auto-suggest-on-change-initial-input-focus-singular";
export const ON_CHANGE_SELECT_OPTION_ENABLED =
  "auto-suggest-on-change-select-option-enabled";
export const ON_FOCUS_VALUE = "auto-suggest-on-focus-value";
export const ON_FOCUS_MENU_BASE = "auto-suggest-on-focus-menu-base";
export const ON_FOCUS_MENU_SELECTED = "auto-suggest-on-focus-menu-selected";
export const ON_FOCUS_MENU_DISABLED = "auto-suggest-on-focus-menu-disabled";
export const ON_FILTER_INPUT_PART = "auto-suggest-on-filter-input-part";
export const ARRAY_INDEX_FORMAT = "auto-suggest-array-index-format";
export const SCREEN_READER_STATUS = "auto-suggest-screen-reader-status";
